import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import { ThemeProvider } from "./contexts/ThemeContext";
import { DialogProvider } from "./components/ui/DialogProvider";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from "./components/Login";
import AdminPanel from "./components/AdminPanel";
import ChatWidget from "./components/ChatWidget";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      if (data?.session?.user) {
        setUser(data.session.user);
      }
    };

    checkSession();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
  };

  return (
    <ThemeProvider>
      <DialogProvider>
        <div className="App">
          {user ? (
            <>
              <AdminPanel user={user} onLogout={handleLogout} />
              <ChatWidget user={user} />
            </>
          ) : (
            <Login onLogin={setUser} />
          )}
        </div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </DialogProvider>
    </ThemeProvider>
  );
}

export default App;
